import { useCallback } from 'react';
import { useImportDateFnsLocale } from '@elfsight/widget-utils';
import { format } from 'date-fns';
import { capitalize } from 'es-toolkit';
import { useBusinessHoursProps } from '../../business-hours-props-context';

export const useWeekdayFormatter = () => {
  const { dayMonthFormat, language } = useBusinessHoursProps();
  const locale = useImportDateFnsLocale(language?.language ?? 'en');

  return useCallback(
    (date: Date) => {
      const formatType = dayMonthFormat === 'full' ? 'eeee' : 'eee';

      return format(date, formatType, { locale }).replace(/\S+/g, capitalize);
    },
    [dayMonthFormat, locale]
  );
};
